<template>
	<div class="scene-container">
		<el-row>
			<el-col :lg="4" :xl="4">
				<div class="hidden-md-and-down">&nbsp;</div>
			</el-col>
			<el-col :lg="16" :xl="16" class="hidden-md-and-down">
				<div class="center">
					<h4>应用场景</h4>
					<div class="item" v-for="item in data" :key="item.id">
						<div class="left">
							<img :src="item.src" />
						</div>
						<div class="right">
							<h4>{{item.title}}</h4>
							<p class="title">{{item.desc}}</p>
							<div class="content" v-for="content in item.contents" :key="content.title">
								<p>{{content.title}}</p>
								<span>{{content.content}}</span>
							</div>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :xs="24" :sm="24" :md="24" class="hidden-lg-and-up">
				<div class="center">
					<h4>应用场景</h4>
					<div class="item" v-for="item in data" :key="item.id" :style="{backgroundImage:'url('+item.src+')'}">
						<div class="right">
							<div class="box">
								<h4>{{item.title}}</h4>
								<p class="title">{{item.desc}}</p>
								<div class="content" v-for="content in item.contents" :key="content.title">
									<p class="title">{{content.title}}</p>
									<p>{{content.content}}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :lg="4" :xl="4">
				<div class="hidden-md-and-down">&nbsp;</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		name: 'scenePCS',
		props: ['data']
	}
</script>

<style>
	.scene-container {
		width: 100%;
		background-color: #EAF2F9;
	}

	.scene-container .center {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	/* pc端 */
	@media (min-width:992px) {
		.scene-container .center h4 {
			color: #000000;
			line-height: 120px;
			font-size: 20px;
		}

		.scene-container .center .item {
			display: flex;
			width: 100%;
			background-color: #FFFFFF;
			border: 1px solid rgba(215, 222, 232, 1);
			border-left-width: 10px;
			margin-bottom: 20px;
		}

		.scene-container .center .item:hover {
			border: 1px solid #409EFF;
			border-left-width: 10px;
		}

		.scene-container .center .item .left {
			height: 100%;
			background-color: rgba(215, 222, 232, 1);
		}

		.scene-container .center .item .right {
			display: flex;
			align-items: flex-start;
			flex-direction: column;
			margin: 39px 39px 0 39px;
		}

		.scene-container .center .item .right h4 {
			margin: 0;
			line-height: 1.1;
		}

		.scene-container .center .item .right p {
			font-size: 16px;
			font-family: "microsoft yahei";
			color: rgba(87, 90, 102, 1);
			float: inherit;
			line-height: initial;
		}

		.scene-container .center .item .right p.title {
			margin-top: 17px;
		}

		.scene-container .center .item .right span {
			font-size: 14px;
			font-family: "microsoft yahei";
			color: rgba(132, 132, 132, 1);
		}

		.scene-container .center .item .right .content {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			margin-top: 17px;
		}
	}

	/* 移动端 */
	@media (max-width:992px) {
		.scene-container .center h4 {
			color: #000000;
			line-height: 60px;
			font-size: 18px;
			font-weight: 500;
		}

		.scene-container .center .item {
			background-repeat: no-repeat;
			background-size: 100% 100%;
			width: 95%;
			margin-bottom: 10px;
			min-height: 230px;
		}

		.scene-container .center .item .right {
			background-color: rgba(255, 255, 255, 0.7);
			width: 100%;
			min-height: 230px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			/* align-items: center; */
			/* padding: 10px 10px 0; */
		}

		.scene-container .center .item .right h4 {
			line-height: 1.1;
			font-weight: 500;
			text-align: left;
			align-self: flex-start;
			margin-bottom: -5px;
		}

		.scene-container .center .item .right .box {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			margin: 5px;
			width: 95%;
		}

		.scene-container .center .item .right .content {
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: flex-start;
		}

		.scene-container .center .item .right p {
			font-size: 12px;
			font-family: "microsoft yahei";
			text-align: left;
			line-height: 1.2;
			color: #000000;
		}

		.scene-container .center .item .right p.title {
			font-size: 14px;
			font-family: "microsoft yahei";
			color: #000000;
			float: inherit;
			line-height: 1.4;
			text-align: left;
			font-weight: 500;
			margin-top: 5px;
		}
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/ScenePCS.vue